export const ENVIRONMENT = Object.freeze({
  DEVELOPMENT: 'development',
  STAGING: 'staging',
  PRODUCTION: 'production',
});

export const APP_NAME = Object.freeze({
  MARPPLE: 'mp',
  MARPPLE_SHOP: 'creator',
  NESS: 'ness',
  DF: 'df',
  SCHEDULER: 'scheduler',
});
